// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"ba9da4b5","580":"865d3e17"}[chunkId] + ".chunk.js";
};